<template lang="pug">
#OTForm
    OTSection(
    step="03"
    v-if="equipment && equipment.id"
    title="Ingreso y descripción de la falla"
    :open="true"
    :section="'ot'"
    )
      b-container

        //- Sección colapasada
        div(v-if="!collapseOT && ot")
          b-form-group
            div
              label.samtek-label(for="input-name") OT:
              slot {{ ' ' + ot.ot }}
            div
              label.samtek-label(for="input-name") Tipo de ingreso:
              slot {{ ' ' + ot.tipo_servicio.nombre }}

        b-collapse(v-model="collapseOT" id="collapse-ot-section" visible)
          b-form
            b-row
              b-col
                div(v-if="!ot")
                  p.samtek-folio(v-if="!ot") Folio OT: Sin asignar
                div(v-else-if="form.ot")
                  p.samtek-folio Folio OT: {{ form.ot }}

            //----------------------------------------------------------------
            b-row
              b-col(cols="12" md="4")
                b-form-group
                  label.samtek-label(for="input-servicio") Tipo de Servicio
                  b-form-select(
                      id="input-servicio"
                      v-model="form.tipo_servicio"
                      :options="serviceOptions"
                      :disabled="ov_id ? true : false "
                      :state="$v.form.tipo_servicio.$dirty? !$v.form.tipo_servicio.$invalid : null"
                      @input="$v.form.tipo_servicio.$touch()"
                  )
                    .errors(v-if="$v.form.tipo_servicio.$dirty")
                      b-form-invalid-feedback(:state="$v.form.tipo_servicio.required")
                          | Campo requerido

              b-col(cols="12" md="4" v-if="client && client.tipo_cliente === 1")
                b-form-group
                  label.samtek-label(for="input-failClientReport") Despacho
                  b-select(v-model="form.despacho", :options="optionsDespacho" id="select-despacho" )
                  .errors(v-if="$v.form.despacho.$dirty")
                    b-form-invalid-feedback(:state="$v.form.despacho.required")
                      | Campo requerido

              b-col(cols="12" md="4")
                b-form-group
                  label.samtek-label(for="input-falla") Tipos de Falla
                  v-select(
                      id="input-falla"
                      v-model="form.tipo_falla"
                      multiple
                      :options="tiposFallaOptions"
                      :state="$v.form.tipo_falla.$dirty? !$v.form.tipo_falla.$invalid : null"
                      @input="$v.form.tipo_falla.$touch()"
                  )
                  .errors(v-if="$v.form.tipo_falla.$dirty")
                    b-form-invalid-feedback(:state="$v.form.tipo_falla.required")
                        | Campo requerido

            //----------------------------------------------------------------
            b-row
              b-col(cols="12")
                b-form-group
                  label.samtek-label(for="input-observations") Observaciones
                  b-form-textarea(
                    id="input-observations"
                    v-model="form.observaciones"
                    :state="$v.form.observaciones.$dirty ? !$v.form.observaciones.$invalid : null"
                    @input="$v.form.observaciones.$touch()"
                  )
                  .errors(v-if="$v.form.observaciones.$dirty")
                    b-form-invalid-feedback(:state="$v.form.observaciones.required")
                      | Campo requerido

            //----------------------------------------------------------------
            b-row
              b-col(cols="12")
                b-form-group
                  label.samtek-label(for="input-failClientReport") Reporte de Falla del Cliente
                  b-form-textarea(
                    id="input-failClientReport"
                    v-model="form.reporte_falla_cliente"
                    :state="$v.form.reporte_falla_cliente.$dirty? !$v.form.reporte_falla_cliente.$invalid : null"
                    @input="$v.form.reporte_falla_cliente.$touch()"
                  )
                  .errors(v-if="$v.form.reporte_falla_cliente.$dirty")
                    b-form-invalid-feedback(:state="$v.form.reporte_falla_cliente.required")
                      | Campo requerido

            //----------------------------------------------------------------
            b-row(v-if="form.tipo_servicio=== 1 || form.tipo_servicio=== 2||form.tipo_servicio=== 3")
              b-col(cols="12" md="4")
                b-form-group
                  label.samtek-label(for="input-boleta") Número de boleta
                  b-form-input(
                    id="input-n-boleta"
                    v-model="form.numero_boleta"
                    :state="$v.form.numero_boleta.$dirty ? !$v.form.numero_boleta.$invalid : null"
                    placeholder="Ingrese número de boleta"
                )
                .errors(v-if="$v.form.numero_boleta.$dirty")
                    b-form-invalid-feedback(:state="$v.form.numero_boleta.required")
                    | Campo requerido

              b-col(cols="12" md="4")
                b-form-group
                  label.samtek-label(for="input-fecha_compra") Fecha de compra
                  b-form-datepicker(
                    id="input-purchaseDate"
                    v-model="form.fecha_de_compra"
                    locale="es-CL"
                    :state="$v.form.fecha_de_compra.$dirty ? !$v.form.fecha_de_compra.$invalid : null"
                    :max="new Date()"
                    select-variant="primary"
                    placeholder="Ingrese una fecha"
                )
                .errors(v-if="$v.form.fecha_de_compra.$dirty")
                    b-form-invalid-feedback(:state="$v.form.fecha_de_compra.required")
                    | Campo requerido

              b-col(cols="12" md="4")
                b-form-group
                  b-form-checkbox.mt-4.pt-2(
                    id="checkbox-need3x3"
                    v-model="form.need3x3"
                  ) ¿Cliente exige cambio o 3x3?

            //----------------------------------------------------------------
            b-row
              b-col(cols="12" md="6" v-if="client && client.tipo_cliente === 2")
                b-form-group
                    label.samtek-label(for="input-codigoRetail") Codigo Retail
                    b-form-input(
                        id="input-codigoRetail"
                        v-model="form.codigo_retail"
                    )
              b-col( cols="12" md="6" v-if="client && client.tipo_cliente === 2" )
                b-form-group
                  label.samtek-label(for="input-guia_ingreso") Guia de Despacho
                  b-form-input(
                    iD="input-guia_ingreso"
                    v-model="form.guia_despacho_ingreso"
                    :state="$v.form.guia_despacho_ingreso.$dirty ? !$v.form.guia_despacho_ingreso.$invalid : null"
                    @input="$v.form.guia_despacho_ingreso.$touch()"
                  )
                  .errors(v-if="$v.form.guia_despacho_ingreso.$dirty")
                      b-form-invalid-feedback(:state="$v.form.guia_despacho_ingreso.required")
                          | Campo requerido

            //----------------------------------------------------------------
            b-row
              b-col(cols="12" md="6", v-if="client && client.tipo_cliente === 1 && form.tipo_servicio !== 4")
                b-form-group
                  label.samtek-label(for="input-sucursal") Tienda
                  b-input-group
                    b-select(
                      v-model="form.sucursal",
                      id="input-sucursal",
                      :state="$v.form.sucursal.$dirty ? !$v.form.sucursal.$invalid : null"
                    )
                      b-form-select-option(v-for="empresa in empresas", :value="empresa.id") {{ empresa.razon_social }}
                    b-input-group-append
                      b-button(
                        variant="primary"
                        @click="showClienteEmpresaModal = true"
                      ) Nueva
                      ClienteEmpresaModal(v-model="showClienteEmpresaModal" @created="handleNewTienda")
                .errors(v-if="$v.form.sucursal.$dirty")
                    b-form-invalid-feedback(:state="$v.form.sucursal.required")
                      | Campo requerido


            //----------------------------------------------------------------
            b-row
              b-col
                b-form-group
                  label.samtek-label() Documentos
                b-row
                  b-col(cols='12' md='4' v-if="boletaUrl")
                    h6.input-label Boleta:
                    .flex-row.align-items-center.gap-1(v-if="boletaType === 'pdf'")
                      b-icon.device-icon.h3(icon="file-pdf" variant="black")
                      p {{ boletaName.split('/').pop() }}
                    img.device-image(v-else :src="boletaUrl" alt="Imagen Boleta")
                UploadFile( ref="upload" :attachmentType="ARCHIVO_ADJUNTO_TIPO.INGRESO")

            //----------------------------------------------------------------
            b-row
              b-col
                button.samtek-btn-primary.mr-2(type="button" @click="onSubmit", :disabled="loading" id="submit-ot-form")
                  | {{ !form.ot ? 'Crear' : ( ot.estado && ['Pre ingreso', 'Pre ingreso regiones'].includes(ot.estado.estado.nombre)  ? 'Completar Pre-Ingreso' : 'Editar')}}
</template>

<script>
import { WebCam } from 'vue-web-cam'
import { required, requiredIf } from 'vuelidate/lib/validators'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import OTSection from './OTSection.vue'
import UploadFile from './UploadFile.vue'
import ClienteEmpresaModal from './ClienteEmpresaModal.vue'

export default {
  components: {
    'vue-web-cam': WebCam,
    OTSection,
    UploadFile,
    VueTypeaheadBootstrap,
    ClienteEmpresaModal,
  },
  props: ['ov_id'],
  name: 'OTForm',
  validations: {
    form: {
      tipo_servicio: { required },
      tipo_falla: { required },
      observaciones: { required },
      reporte_falla_cliente: { required },
      guia_despacho_ingreso: {
        required() {
          return this.client.tipo_cliente === 2
            ? !!this.form.guia_despacho_ingreso
            : true
        },
      }, // eslint-disable-line
      sucursal: {
        required() {
          return this.client.tipo_cliente === 1 &&
            (this.form.tipo_servicio === 1 ||
              this.form.tipo_servicio === 2 ||
              this.form.tipo_servicio === 3)
            ? !!this.form.sucursal
            : true
        },
      }, // eslint-disable-line
      fecha_de_compra: {
        required() {
          return this.form.tipo_servicio === 1 ||
            this.form.tipo_servicio === 2 ||
            this.form.tipo_servicio === 3
            ? !!this.form.fecha_de_compra
            : true
        },
      }, // eslint-disable-line
      numero_boleta: {
        required() {
          return this.form.tipo_servicio === 1 ||
            this.form.tipo_servicio === 2 ||
            this.form.tipo_servicio === 3
            ? !!this.form.fecha_de_compra
            : true
        },
      }, // eslint-disable-line
      despacho: {
        required: requiredIf(function () {
          return this.client.tipo_cliente === 1
        }),
      }, // eslint-disable-line
    },
  },
  data() {
    return {
      openCamera: false,
      collapseDocuments: false,
      collapseOT: true,
      deviceId: null,
      devices: [],
      camera: null,
      despacho: '',
      // fotos: [],
      searching: false,
      selectedStore: null,
      loading: false,
      showClienteEmpresaModal: false,
      boletaUrl: null,
      boletaType: null,
      boletaName: null,
      tiposFallaOptions: [],
      // tiendaQuery: null,
      // tiendaList: [],
      // fieldsFotos: [
      //   { key: 'file', label: '#' },
      //   { key: 'preview', label: 'Vista previa' },
      //   { key: 'actions', label: 'Acciones' },
      // ],
      form: {
        rma: null,
        codigo_retail: null,
        tipo_servicio: null,
        tipo_falla: null,
        observaciones: null,
        reporte_falla_cliente: null,
        guia_despacho_ingreso: null,
        // tienda: null,
        sucursal: null,
        fecha_de_compra: null,
        numero_boleta: null,
        need3x3: false,
        despacho: null,
      },
      warrantyOptions: [
        { value: null, text: 'Seleccione' },
        { value: true, text: 'Si' },
        { value: false, text: 'No' },
      ],
      serviceOptions: [
        { value: null, text: 'Seleccione' },
        { value: 1, text: 'Garantía' },
        // { value: 2, text: 'Garantía on site 5D' },
        // { value: 3, text: 'Garantía on site 7x24' },
        { value: 4, text: 'Presupuesto' },
        // { value: 5, text: 'Instalación de partes' },
        // { value: 6, text: 'Garantía de reparación' },
      ],
    }
  },
  methods: {
    ...mapActions('OTStore', [
      'createOT',
      'editOT',
      'getOT',
      'uploadFile',
      'createStore',
      'completPreIngreso',
      'getFileUrl',
      'getFiles',
      'getTiposFalla',
    ]),
    ...mapActions('ClientStore', ['listEmpresas']),
    ...mapActions('Exceptions', ['createExcepcion', 'editExcepcion']),
    ...mapMutations('OTStore', ['SET_OTROS_ACCESORIOS']),

    async setBoletaUrl() {
      await this.getFiles(this.ot.ot)
      const item = this.files?.find(
        (f) => f.type === this.ARCHIVO_ADJUNTO_TIPO.BOLETA
      )
      if (!item) return null

      const payload = {
        fileName: item.name,
        fileType: item.file_type,
        fileId: item.file_id,
      }
      this.boletaUrl = await this.getFileUrl(payload)
      this.boletaType = item.file_type
      this.boletaName = item.name
    },
    async onSubmit() {
      this.loading = true
      if (this.$v.$invalid) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        let tienda_empresa = null
        if (
          this.client.tipo_cliente === 1 &&
          (this.form.tipo_servicio === 1 ||
            this.form.tipo_servicio === 2 ||
            this.form.tipo_servicio === 3)
        ) {
          tienda_empresa = this.form.sucursal
        }
        const sucursal = this.sucursal
          ? this.sucursal.id || this.sucursal
          : null
        const payload = {
          // controlados en otros componentes
          cliente: this.client.id,
          equipo: this.equipment.id,
          tienda_empresa,
          // controlados en este form
          ot: this.form.ot,
          rma: this.form.rma,
          codigo_retail: this.form.codigo_retail,
          tipo_servicio: this.form.tipo_servicio,
          tipo_de_falla: this.form.tipo_falla.map((f) => f.id),
          observaciones: this.form.observaciones,
          otros_accesorios: this.otrosAccesorios,
          reporte_falla_cliente: this.form.reporte_falla_cliente,
          guia_despacho_ingreso: this.form.guia_despacho_ingreso,
          fecha_de_compra: this.form.fecha_de_compra,
          numero_boleta: this.form.numero_boleta,
          // tienda: this.form.tienda ? this.form.tienda.id : null,
          tienda: null,
          exige_cambio_3x3:
            this.form.need3x3 !== null ? this.form.need3x3 : false,
          despacho: this.form.despacho,
        }
        // Datos del dueño del equipo (SILL-1531). ClientForm sólo los publica
        // cuando el cliente es tipo empresa; para persona no se envían.
        if (this.client.tipo_cliente === 2 && this.duenoEquipo) {
          Object.assign(payload, this.duenoEquipo)
        }
        if (
          this.ot.estado &&
          (this.ot.estado?.estado?.nombre === 'Pre ingreso' ||
            this.ot.estado?.estado?.nombre === 'Pre ingreso regiones')
        ) {
          try {
            payload.sucursal_id = sucursal
            await this.completPreIngreso(payload)
            this.$bvToast.toast('Pre ingreso completado exitosamente', {
              variant: 'success',
            })
            this.$emit('changed')
            this.$router.push(`/orden/${this.ot.ot}`)
          } catch (err) {
            this.$bvToast.toast(`Error al completar pre ingreso: ${err}`, {
              variant: 'danger',
            })
          }
        } else {
          payload.sucursal = sucursal
          if (this.isCreatedOT) {
            this.creating = true
            if (
              payload.tipo_servicio === 4 ||
              payload.tipo_servicio === 5 ||
              payload.tipo_servicio === 6
            ) {
              payload.fecha_de_compra = null
              payload.tienda = null
            }
            await this.editOT(payload)
            this.creating = false
            if (this.statusRequest) {
              if (
                this.statusRequest.status === 200 ||
                this.statusRequest.status === 201
              ) {
                this.setOtForm(this.statusRequest.data)
                this.$bvToast.toast(
                  `Orden de Trabajo editada exitosamente${this.statusRequest.data.ot}`,
                  {
                    variant: 'success',
                  }
                )
                // this.uploadFotos();
                this.$refs.upload.uploadNewFiles()
                this.$router.push(`/orden/${this.statusRequest.data.ot}`)
              }
              if (this.statusRequest.status === 400) {
                this.$bvToast.toast(
                  `Error al guardar: ${this.statusRequest.data}`,
                  {
                    variant: 'danger',
                  }
                )
              }
            }
          } else {
            if (this.ov_id) {
              payload.ov = this.ov_id
            }
            await this.createOT(payload)
            this.creating = false
            if (this.statusRequest) {
              if (
                this.statusRequest.status === 200 ||
                this.statusRequest.status === 201
              ) {
                await this.getOT(this.statusRequest.data.ot)
                // verificar excepcion ampliacion de garantia
                const tipos_de_servicio = [1, 2, 3] // Garantía, Garantía on Site 5D , Garantía on Site 7x24
                if (
                  tipos_de_servicio.includes(this.ot.tipo_servicio.id) === true
                ) {
                  this.createExceptionWarrantyExtension()
                }
                // this.uploadFotos();
                this.$refs.upload.uploadNewFiles()
                this.setOtForm(this.statusRequest)
                this.$bvToast.toast(
                  `Orden de Trabajo guardada exitosamente: ${this.statusRequest.ot}`,
                  {
                    variant: 'success',
                  }
                )
                this.$router.push(`/orden/${this.statusRequest.data.ot}`)
              } else {
                this.$bvToast.toast(
                  `Error al guardar: ${this.statusRequest.data}`,
                  {
                    variant: 'danger',
                  }
                )
              }
            }
          }
        }
      }
      this.loading = false
      this.collapseOT = true
    },
    async createExceptionWarrantyExtension() {
      const yearsWarranty = this.equipment.modelo_detail.years_warranty
      const now = moment()
      const garantia = moment(this.ot.fecha_de_compra).add(
        yearsWarranty * 365,
        'days'
      )
      if (now.isAfter(garantia)) {
        const form = {
          estado: 1,
          orden_trabajo: this.ot.ot,
          comentario_solicitud: 'Solicita ampliación de garantía',
          solicitado_por: this.ot.estado.user.id,
          tipo: 'Ampliación de garantía',
        }
        const resp = await this.createExcepcion(form)
        if (resp) {
          const modalId = 'modalId'
          const ok = () => this.$bvModal.hide(modalId)
          let comment
          await this.$bvModal.msgBoxConfirm(
            <div>
              <p>
                Se creo excepción con Ampliación de Garantía para la OT{' '}
                {this.ot.ot}
              </p>
              <label>
                Ingresa comentario:
                <textarea
                  name="postContent"
                  rows={3}
                  cols={50}
                  vModel={comment}
                  vOn:keyup_enter={ok}
                />
              </label>
            </div>,
            {
              id: modalId,
              title: 'Orden de trabajo con Excepción',
              size: 'md',
              okVariant: 'success',
              centered: true,
              noCloseOnBackdrop: true,
            }
          )
          form.id = resp.data.id
          form.comentario_solicitud += `: ${comment}`
          await this.editExcepcion(form)
        }
      }
    },
    async submitFile() {
      if (!this.checkFiletypeForUpload(this.uploadingFile.type)) {
        this.$bvToast.toast('Solo se permiten archivos .jpg, .png, .pdf', {
          variant: 'danger',
        })
        return
      }
      const formData = new FormData()
      formData.append('archivo', this.uploadingFile)
      if (this.statusRequest.data.ot) {
        formData.append('orden_trabajo', this.statusRequest.data.ot)
      }
      await this.uploadFile(formData)
    },
    checkFiletypeForUpload(fileType) {
      return ['image/jpeg', 'image/png', 'application/pdf'].includes(fileType)
    },
    async setOtForm(ot) {
      if (ot) {
        this.SET_OTROS_ACCESORIOS(ot.otros_accesorios ?? null)
        this.form = {
          ...ot,
          tipo_falla:
            typeof ot.tipo_falla === 'object'
              ? ot.tipo_falla.id
              : ot.tipo_falla,
          tipo_servicio:
            typeof ot.tipo_servicio === 'object'
              ? ot.tipo_servicio.id
              : ot.tipo_servicio,
          sucursal: ot.tienda_empresa?.id,
        }
        this.setBoletaUrl()
        // this.$nextTick(() => {
        //   this.$refs.tiendaInput.inputValue = this.form?.tienda?.nombre;
        // });
      }
    },
    documentCollapse(collapse) {
      this.collapseDocuments = collapse
    },
    handleNewTienda(empresaId) {
      this.listEmpresas()
      this.$nextTick(() => {
        this.form.sucursal = empresaId
      })
    },
  },
  computed: {
    ...mapGetters('OTStore', [
      'ot',
      'statusRequest',
      'files',
      'otrosAccesorios',
      'duenoEquipo',
    ]),
    ...mapGetters('ClientStore', ['client', 'sucursal', 'empresas']),
    ...mapGetters('EquipmentStore', ['equipment']),
    ...mapGetters('AuthenticationStore', ['user']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,

    isCreatedOT() {
      return this.ot && this.ot.ot
    },

    optionsDespacho() {
      if (this.form.tipo_servicio === 4) {
        return [
          { value: null, text: 'Seleccione...' },
          { value: 'ENVIO', text: 'Envío' },
          { value: 'RETIRO', text: 'Retiro por el cliente' },
        ]
      }
      return [
        { value: null, text: 'Seleccione...' },
        { value: 'ENVIO', text: 'Envío' },
        { value: 'RETIRO', text: 'Retiro por el cliente' },
        { value: 'ON_SITE', text: 'On Site' },
      ]
    },

    filteredServiceOptions() {
      // Si es empresa (tipo_cliente === 2), solo permitir Garantía
      if (this.client && this.client.tipo_cliente === 2) {
        return [{ value: 1, text: 'Garantía' }]
      }
      return this.serviceOptions
    },

    device() {
      return this.devices.find((n) => n.deviceId === this.deviceId)
    },
    // filelistFotos() {
    //   if (this.fotos) {
    //     return this.fotos.map((f, index) => ({
    //       index,
    //       file: index + 1,
    //       preview: f,
    //     }));
    //   }
    //   return [];
    // },
  },
  watch: {
    ot() {
      if (this.ot) this.setOtForm(this.ot)
    },
    camera(id) {
      this.deviceId = id
    },
    devices() {
      const [first, ...tail] = this.devices //eslint-disable-line
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
    'form.tipo_servicio': function fn() {
      if (
        this.form.tipo_servicio === 1 ||
        this.form.tipo_servicio === 2 ||
        this.form.tipo_servicio === 3 ||
        this.form.tipo_servicio === 4
      ) {
        this.collapseDocuments = true
      }
      // this.form.despacho = this.form.tipo_servicio === 4 ? 'RETIRO' : null
    },
  },
  async created() {
    this.listEmpresas()
    // En caso de venir desde una OV se selecciona el tipo de servicio como "Presupuesto"
    if (this.ov_id) {
      this.form.tipo_servicio = 4
    }
    const resp = await this.getTiposFalla()
    this.tiposFallaOptions = resp.data.map((falla) => {
      return {
        id: falla.id,
        label: `${falla.name} (${falla.tipo_de_falla})`,
      }
    })
    if (this.ot && this.ot.ot) {
      this.setOtForm(this.ot)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '~vue-select/dist/vue-select.css';

.samtek-label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201c;
  display: block;
  margin-bottom: 6px;
}

.samtek-folio {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #23201c;
  margin-bottom: 12px;
}

.samtek-btn-primary {
  height: 45px;
  padding: 10px 20px;
  background-color: #fece2f;
  color: #23201c;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.88;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.preview,
.capture {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

img {
  width: 100%;
}

.thumbnail {
  height: 60px;
  width: auto;
}

.device-image {
  width: 100%;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #cbcbcb;
  margin-top: 5px;
}

.device-icon {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #cbcbcb;
  margin-top: 5px;
}
</style>
